import { Button } from "@/ui-components/ui/button";
import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import { Edit2, X } from "lucide-react";
import { useState } from "react";
import NumbersFetcher from "./fetcher";

const NumbersSettings = () => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Berechnungseinstellungen</PageTitle>
          <Button onClick={() => setIsEditing(!isEditing)} className="gap-2" variant="secondary">
            <span>{isEditing ? "Abbrechen" : "Bearbeiten"}</span>
            {isEditing ? <X size={16} /> : <Edit2 size={16} />}
          </Button>
        </div>
      </PageTitleContainer>
      <NumbersFetcher isEditing={isEditing} setIsEditing={setIsEditing} />
    </div>
  );
};

export default NumbersSettings;
